<template>
    <div class="intelligence-table">
        <h3 class="intelligence-table__title">{{ $t('pages.intelligence.delivery.charts.channel_table') }}</h3>
        <div v-if="channels.length" class="intelligence-table__wrapper">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('pages.intelligence.delivery.table.channel') }}</th>
                        <th>{{ $t('pages.intelligence.delivery.table.attempts') }}</th>
                        <th>{{ $t('pages.intelligence.delivery.table.successes') }}</th>
                        <th>{{ $t('pages.intelligence.delivery.table.failures') }}</th>
                        <th>{{ $t('pages.intelligence.delivery.table.confirmed') }}</th>
                        <th>{{ $t('pages.intelligence.delivery.table.success_rate') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in channels" :key="row.channel">
                        <td>{{ row.channel }}</td>
                        <td>{{ row.attempts }}</td>
                        <td>{{ row.successes }}</td>
                        <td>{{ row.failures }}</td>
                        <td>{{ row.confirmed }}</td>
                        <td>{{ formatPercent(row.successRate) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="intelligence-table__empty">{{ $t('pages.intelligence.delivery.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            channels: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            formatPercent(value) {
                if (value === null || value === undefined) return '—'
                return `${value}%`
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-table {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-table__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-table__wrapper {
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    th,
    td {
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
    }

    th {
        color: #6b7280;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
    }

    td:first-child {
        font-family: monospace;
        color: #1e3a8a;
        text-transform: capitalize;
    }

    .intelligence-table__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
